import { useCallback, useEffect, useState } from "react";
import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";

const icons = {
  error: AlertCircle,
  info: Info,
  success: CheckCircle2,
  warning: AlertCircle,
};

const styles = {
  error: "border-red-200 bg-red-50 text-red-800",
  info: "border-blue-200 bg-blue-50 text-blue-800",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  warning: "border-amber-200 bg-amber-50 text-amber-800",
};

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = "info") => {
    const id = `${Date.now()}-${Math.random()}`;
    setToasts((current) => [...current, { id, message, type }]);
    return id;
  }, []);

  const dismiss = useCallback((id) => {
    setToasts((current) => current.filter((item) => item.id !== id));
  }, []);

  useEffect(() => {
    if (!toasts.length) return undefined;
    const timers = toasts.map((item) => window.setTimeout(() => dismiss(item.id), 4200));
    return () => timers.forEach(window.clearTimeout);
  }, [dismiss, toasts]);

  return { dismiss, toast, toasts };
}

export function ToastStack({ dismiss, toasts }) {
  if (!toasts.length) return null;

  return (
    <div className="fixed right-5 top-5 z-[2000] grid w-[calc(100vw-2.5rem)] max-w-sm gap-3">
      {toasts.map((item) => {
        const Icon = icons[item.type] || Info;
        return (
          <div
            className={`flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm font-bold shadow-lg ${styles[item.type] || styles.info}`}
            key={item.id}
          >
            <Icon className="mt-0.5 h-5 w-5 flex-shrink-0" />
            <div className="min-w-0 flex-1 leading-5">{item.message}</div>
            <button className="rounded-lg p-1 opacity-70 hover:opacity-100" onClick={() => dismiss(item.id)} type="button">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
